import { Checkbox as FCheckbox } from '@forest/forms';
import { connect, mapProps } from '@formily/react';
export const Checkbox = connect(FCheckbox, mapProps({
    value: 'isChecked',
}));
Checkbox.Group = connect(FCheckbox.Group, mapProps({
    dataSource: 'options',
}));
export default Checkbox;
